import { Base } from "@app/controllers/base";

export default class extends Base {
  static targets = ["page", "prev", "next", "indicator"]
  static values = { current: { type: Number, default: 1 } }

  connect() {
    this.totalPages = this.pageTargets.length
    this._render()
  }

  prev() {
    if (this.currentValue > 1) {
      this.currentValue--
      this._render()
    }
  }

  next() {
    if (this.currentValue < this.totalPages) {
      this.currentValue++
      this._render()
    }
  }

  _render() {
    this.pageTargets.forEach((page, i) => {
      page.classList.toggle("hidden", i + 1 !== this.currentValue)
    })
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.textContent = `${this.currentValue} / ${this.totalPages}`
    }
    if (this.hasPrevTarget) {
      this.prevTarget.disabled = this.currentValue === 1
    }
    if (this.hasNextTarget) {
      this.nextTarget.disabled = this.currentValue === this.totalPages
    }
  }
}
